module.exports = __webpack_public_path__ + "img/sst-thumbnail.c1f1eef2.png";